<template>
    <div class="forward-email">

        <div class="navbar-wrapper">
            <a class="btn btn-sync" @click="openSyncModal()" :disabled="preloader">Sync contacts</a>
            <button class="btn forward-btn" @click="forward()"
                    :disabled="forwardDisabled || forwarding || preloader || selectedDeals.length < 1 ">
                Forward {{selectedEmailsCount}} E-Mail{{plural}}
            </button>
        </div>
        <div class="clear" v-if="!forwarded ">
            <div class="sync-wrapper">
                <div v-if="preloader">
                    <preloader class="preloader-position"></preloader>
                    <div class="load-text">
                        <p>This can take few minutes. Please wait...</p>
                    </div>
                </div>
            </div>
            <div id="emails" v-if="!preloader">
                <div v-if="deals.length > 0 && !preloader">
                    <label class="typo__label">Deals</label>
                    <multiselect v-model="selectedDeals"
                                 :options="dealsDropDown"
                                 :multiple="true"
                                 :close-on-select="false"
                                 :clear-on-select="false"
                                 :hide-selected="true"
                                 :preserve-search="true"
                                 group-values="emails"
                                 group-label="type"
                                 track-by="id"
                                 label="name"
                                 :disabled="preloader"
                                 placeholder="Select deals">
                    </multiselect>
                </div>
                <div v-if="deals.length === 0" class="text-center">You have no available deals.</div>
            </div>
            <button v-if="!preloader" @click="logout()" :disabled="preloader" class="btn logout-btn ">Sign out</button>

        </div>
        <div v-if="forwarded">
            <h3>Forwarded E-Mail(s)</h3>
            <p>Your E-Mail(s) have been forwarded to the selected deal(s).</p>
        </div>
        <sync-modal v-if="syncModal" @close="syncModal = $event" @ok="sync()"
                    :newContactsLength="newContacts.length"></sync-modal>
        <error-modal v-if="errorModal" @close="errorModal = $event" @ok="errorModal = false"></error-modal>
    </div>
</template>

<script>

    import Multiselect from 'vue-multiselect';
    import _ from 'lodash';
    import DealsService from '../services/DealsService';
    import AuthService from '../services/AuthService';
    import ContactService from '../services/ContactsService';
    import SyncContact from './SyncContactsModal';
    import EmailService from '../services/EmailService';
    import Preloader from './Preloader';
    import ErrorModal from './ErrorModal';

    export default {
        components: {
            Multiselect,
            'sync-modal': SyncContact,
            'error-modal': ErrorModal,
            preloader: Preloader
        },
        watch: {
            forwarded () {
                setTimeout(() => {
                    this.forwarded = false;
                }, 5000);
            }
        },
        data () {
            return {
                deals: [],
                selectedDeals: [],
                dealsDropDown: [],
                newContacts: [],
                forwarded: false,
                forwarding: false,
                syncModal: false,
                officePackage: null,
                preloader: false,
                errorModal: false
            };
        },
        async created () {
            this.preloader = true;
            this.deals = await DealsService.getDeals();
            this.preloader = false;

            this.dealsDropDown = [
                {
                    type: 'Deals',
                    emails: this.deals
                }
            ];
        },

        methods: {
            async openSyncModal () {
                this.preloader = true;
                const { data } = await ContactService.getSTContacts();
                ContactService.getOutlookContacts((OutlookContacts) => {
                    const outlookEmails = [];
                    _.forEach(ContactService.getEmailsFromEWSXML(OutlookContacts.value), (emailAddress) => {
                        const emailEntries = emailAddress.childNodes;
                        _.forEach(emailEntries, (emailEntry) => {
                            outlookEmails.push(emailEntry.textContent);
                        });
                    });
                    this.newContacts = ContactService.filterContacts(data, outlookEmails);
                    this.syncModal = true;
                    this.preloader = false;
                });
            },
            async sync () {
                await ContactService.createContacts(this.newContacts, (isSent) => {
                    this.syncModal = isSent;
                });
            },
            async forward () {
                this.forwarding = true;
                const forwardTo = [];
                _.forEach(this.selectedDeals, (deal) => {
                    forwardTo.push(deal.email);
                });
                EmailService.sendMail(forwardTo, () => {
                    this.errorModal = true;
                });
                this.forwarding = false;
                this.forwarded = true;
                this.selectedDeals = [];
            },
            logout () {
                AuthService.logout();
                this.$router.push('/');
            }
        },
        computed: {
            selectedEmailsCount () {
                if (this.selectedDeals.length > 0) {
                    return this.selectedDeals.length;
                }
                return '';
            },
            plural () {
                return this.selectedDeals.length > 1 ? 's' : '';
            },
            forwardDisabled () {
                return this.selectedDeals.length === 0;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Email.vue